<template>
   <button class="button button-large mr-0 is-clickable is-block" :class="rowData.items?.length ? 'is-dark ': 'is-outlined'"
    @click="triggerItemsModal()"
    :disabled="activeScreen ==='shipping-order-view'"
    v-if="rowField.id === 'items' && !rowField.isDisabled">
    <h3 class="is-size-3">{{rowData.items?.length }} </h3>
       <i class="icon-attacheditemsOL"></i>
    </button>
    <div class="is-block has-text-centered" 
      v-else-if="rowField.id === 'items'">
      <h3 class="is-size-3 has-text-weight-semibold">{{rowData.items?.length }} </h3>
      <i class="icon-attacheditems"></i>
    </div>
    <button v-if="rowField.id === 'shipDelivs'"
      @click="triggerItemsModal()"
      class="button button-large  is-clickable is-block mr-0"
      :class="deliveryCount ? 'is-dark ': 'is-outlined'"
      >
      <h3 class="is-size-3">
        {{ deliveryCount }}
      </h3>
        <i class="icon-attacheddeliveries"></i>
    </button>
    <button v-if="rowData.source?.kind === 'ProductionOrder' && rowField.id === 'order'"
      @click="triggerItemsModal()"
      class="button button-large  is-clickable mf-fm-background mr-0">
        <i class="icon-productionorder mt-3"></i>
    </button>
     <button v-else-if="rowData.source?.kind === 'Sourcing' && rowField.id === 'order'"
      @click="triggerItemsModal()"
      class="button button-large is-clickable mf-mm-background mr-0">
        <i class="icon-materialorder mt-3 qaqc2x"></i>
    </button>
      <i class="icon-inventory has-text-dark qaqc2x is-flex is-justify-content-center is-align-items-center"
         v-else-if="rowData.source?.from !== 'card' && rowField.id === 'order'"></i>

</template>

<script>

import { defineComponent, inject, onMounted, reactive, toRefs } from 'vue';
import { useStore } from 'vuex';
import { filter, isEmpty, find } from 'lodash';

export default defineComponent({
  name: 'ShippingItemsIconField',
  props: [
    'value',
    'rowField',
    'rowData',
    'deliveryLength',
    'isDisabled'
  ],
  setup(props) {
    const emitter = inject('emitter');
    const store = useStore();
    const state = reactive({
      itemDelivery: [],
      activeScreen: store.state.activeScreen,
      deliveryCount: 0,
    })
    
    const triggerItemsModal = () => {
      // trigger delivery items modal
      const emitObj = {
        rowData: props.rowData,
        isUnscheduledRow: props.rowData.id === 'unscheduled',
        isActive: true,
      };
      if (props.rowField.id === 'shipDelivs') emitter.emit('toggle:isItemsDelivery', emitObj);
      else if (props.rowField.id === 'order') emitter.emit('toggle:isSourceOrder', emitObj);
      else emitter.emit('toggle:isDeliveryItems', emitObj);
    };

    onMounted( async () => {
      if (props.rowField.id === 'shipDelivs') {
        for (let del of props.deliveryLength) {
          if (del.items.length && !['underDelivered', 'unscheduled'].includes(del.id)) {
            const item = find(del.items, (item) => props.rowData.source.kind === 'ProductionOrder' || (props.rowData.source.kind === 'Assembly' && !item.catId) ?
            props.rowData._id === item._id : (props.rowData.catId === item.catId && props.rowData._id === item._id))
            if (!isEmpty(item))  state.deliveryCount += 1;
          }
          const delivery = filter(del.items, (item) => props.rowData.source.kind === 'ProductionOrder' || (props.rowData.source.kind === 'Assembly' && !item.catId) ?
            props.rowData._id === item._id : props.rowData.catId === item.catId);
          if (!isEmpty(delivery)) state.itemDelivery.push(delivery);
        }
      }
    })

    return {
      ...toRefs(state),
      triggerItemsModal,
    };
  },
});

</script>
<style scoped>
.mf-fm-background i {
  font-size: 40px !important;
}
.has-text-centered i {
  font-size: 40px !important;
}
.has-text-centered i:hover {
  color: #000 !important;
}
</style>
